module.exports = __webpack_public_path__ + "db91686c8e2398a26a1c55d50e21a24c.png";